module.exports = __webpack_public_path__ + "img/proyecto_7.b64495c8.png";